import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { HeaderService } from 'src/app/services/header.service';
import { Subscription } from 'rxjs';
import { NotifyService } from 'src/app/services/notify.service';
import { AlertService } from 'src/app/services/alert.service';
import { LookupService } from 'src/app/services/lookup.service';
import { environment } from 'src/environments/environment.local';
import { ToastrService } from 'ngx-toastr';

declare var $: any
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  currentUser: any;
  roleId = 4;
  roleName = 'Guest';
  menuList: any[];
  isLoggedIn: boolean = false;
  IsDLMS: number;
  groupName: any;
  enterpriseid: any;
  userName: any;

  notification: any = [];
  userNotifications: any[] = [];
  staticMsg: any[] = [];
  dynamicMsg: any[] = [];
  subscription: Subscription;
  LocationName: string;
  storagelotForm: FormGroup;
  lotsubmitted = false;
  StorageLotList = [];
  SelectedStorageLotId: any;
  UserId: number;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public headerService: HeaderService,
    public notifyservice: NotifyService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private lookupService: LookupService,
    private toastr: ToastrService, ) {
    this.authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
      if (!this.currentUser) {
        this.roleId = 4;
        this.roleName = 'Guest';
        this.isLoggedIn = false;
        this.enterpriseid = null;
      }
      else {
        this.notification =[];
        //this.staticMsg=[];
        this.dynamicMsg=[];
        this.enterpriseid = this.currentUser.enterpriseid;
        this.roleId = this.currentUser.roleid;
        this.roleName = this.currentUser.rolename;
        this.groupName = this.currentUser.groupname;
        this.isLoggedIn = true;
        this.IsDLMS = this.currentUser['IsDLMS'];
        this.LocationName = sessionStorage.getItem('Lot');
        this.SelectedStorageLotId = sessionStorage.getItem('LotId');
        this.userName = this.currentUser.username;
        this.UserId = this.currentUser.userid;

        this.createForm();
        if (this.enterpriseid) {
          this.LoadEnterpriseStorageLots();
        }
        console.log(this.currentUser);
        this.LoadUserNotifications(this.currentUser.userid);
        //*******signalR Notification Code*******//
        var connection = $.hubConnection();
        //*******Create a proxy for Hub*****//
        var HubProxy = connection.createHubProxy('notificationHub');
        HubProxy.on('broadcastMessage', (message, Id) => {
          // console.log('Signal R');
          console.log('Signal R=' + message, Id);
          if (message == 'LoadUserNotifications') {
            this.LoadUserNotifications(this.currentUser.userid);
          }
          if (message == 'UserDeactivated' && Id == this.currentUser?.userid.toString()) {
            this.authenticationService.logout();
            this.router.navigate(["/home"]);
            this.notifyservice.clearMessages();
            this.notification =[];
            this.toastr.error("User Deactivated");
          }
          // if(message == 'CheckCountProduct'){
          //   this.getTotalViews();
          // }
        });
        //*****connect to Server URl*******///
        connection.url = environment.BASE_API_URL + 'signalr';
        connection.start({ transport: ['webSockets', 'longPolling'] })
          .done(function () { console.log('Now connected Angular, connection ID=' + connection.id); })
          .fail(function (e) { console.error('Could not connect ' + e); });

        connection.disconnected(function () {
          setTimeout(function () {
            connection.start({ transport: ['webSockets', 'longPolling'] }).done(function () { console.log('Now Reconnected Angular, connection ID=' + connection.id); }).fail(function (e) { console.error('Could not connect ' + e); });
          }, 5000); // Restart connection after 5 seconds.
        });
        //*************************end****************************************//
      }
      this.LoadMenus(this.roleId);

    });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/home']);
    this.notifyservice.clearMessages();
    this.notification =[];
  }

  ngOnInit(): void {

    this.resetNotifications();
  }
  resetNotifications() {    
    this.subscription = this.notifyservice.onMessage().subscribe(message => {
      if (message) {
        if (message.id < 9) {
          this.staticMsg.push(message);
        } else {
          this.dynamicMsg.push(message);
        }

        this.staticMsg = Object.values(this.staticMsg.reduce((acc, cur) => {

          return Object.assign(acc, { [cur.autoid]: cur });
        }, {}));
        this.dynamicMsg = Object.values(this.dynamicMsg.reduce((acc, cur) => {

          return Object.assign(acc, { [cur.autoid]: cur });
        }, {}));
        this.notification = this.staticMsg.concat(this.dynamicMsg);
        //console.log(this.notification);
      } else {
        this.notification = [];
        this.staticMsg = [];
        this.dynamicMsg = [];
      }
    });
  }
  ngAfterViewInit(): void {
    let el = document.querySelector('.toptoscroll');
    el.scrollIntoView({ behavior: "smooth" });
    //window.scrollTo(20, document.body.scrollHeight || document.documentElement.scrollHeight);
  }

  ParentChild(arr) {
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.MenuId] = arrElem;
      mappedArr[arrElem.MenuId]['children'] = [];
    }


    for (var id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.Parentid) {
          mappedArr[mappedElem['Parentid']]['children'].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }
  LoadMenus(roleId) {
    this.headerService.GetMenus(roleId, 'Top', this.enterpriseid).subscribe(res => {
      this.menuList = res;
      // console.log(this.menuList);
      this.menuList = this.ParentChild(this.menuList);
      this.menuList = this.menuList.sort((n1, n2) => {
        if (n1.menuOrder > n2.menuOrder) {
          return 1;
        }
        if (n1.menuOrder < n2.menuOrder) {
          return -1;
        }
        return 0;
      });
      console.log(this.menuList);
    },
      (error) => {
        console.log(error);
      });
  }
  LoadUserNotifications(userId) {
    this.userNotifications=[];
    this.dynamicMsg=[];
    let autoIncrementKey = 30;
    this.notifyservice.GetUserNotifications(userId).subscribe(
      res => {
        this.userNotifications = res;
        if (Array.isArray(this.userNotifications)) {
          for (var item of this.userNotifications) {
            if (item && typeof item === 'object') {
              this.notifyservice.sendMessage({ autoid: autoIncrementKey, id: item.NotificationType, text: item.Notes });
              autoIncrementKey++;
            }
          }
          console.log(this.userNotifications);
        } else {
          console.log("User notifications is not an array:", this.userNotifications);
        }
      },
      error => {
        console.log("Error loading user notifications:", error);
      }
    );
  }

  hideShow(url): boolean {
    // console.log(url);
    if (url == 'home' && this.roleId == 3) {
      return false;
    } else {
      return true;
    }
  }
  navbarOpen = false;

  // toggleNavbar() {
  //   this.navbarOpen = !this.navbarOpen;
  // }

  topNavClick(nv) {
    if (nv.URL == 'multibidvehicles') {
      if (nv.Description == 'Favorites') {
        this.redirectTo(nv.URL, true);
      } else {
        this.redirectTo(nv.URL, false);
      }
    }
  }

  redirectTo(uri: string, ind: boolean) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri], {
        queryParams: {
          favo: ind
        }
      }));
  }
  get fl() { return this.storagelotForm.controls; }

  createForm() {
    this.storagelotForm = this.formBuilder.group({
      StorageLotFormControl: ['', Validators.required],

    });
  }
  LoadEnterpriseStorageLots() {
    this.StorageLotList = [];

    this.lookupService.getEnterpriseStorageLots(this.enterpriseid, this.userName).subscribe(results => {
      this.StorageLotList = results;
      console.log(results);

      if (this.StorageLotList && this.StorageLotList.length >= 1
        && this.SelectedStorageLotId && this.SelectedStorageLotId > 0) {
        let SelectedLotObj = this.StorageLotList.filter(m => m.StorageLotId == this.SelectedStorageLotId)
        this.fl.StorageLotFormControl.setValue(SelectedLotObj[0], {});
        this.fl.StorageLotFormControl.updateValueAndValidity();
        //this.onStorageLotChange();          

      }
    },
      (error) => {
        console.log(error);
      });
  }


  onStorageLotChange() {

    this.lotsubmitted = true;
    this.SelectedStorageLotId = null;

    //this.alertService.clear();
    // stop here if form is invalid

    if (this.storagelotForm.invalid) {
      return;
    }

    if (!this.fl.StorageLotFormControl.value.StorageLotId) {
      this.alertService.showError("Select Location");
      return;

    }
    else {
      this.SelectedStorageLotId = this.fl.StorageLotFormControl.value.StorageLotId;
      var currentLocation = {
        StorageLotId: this.fl.StorageLotFormControl.value.StorageLotId,
        StorageLotName: this.fl.StorageLotFormControl.value.StorageLocationName
      };

      let vsfnum = this.fl.StorageLotFormControl.value.VSFNum ? ' (' + this.fl.StorageLotFormControl.value.VSFNum + ')' : null;
      sessionStorage.setItem('Lot', currentLocation.StorageLotName + vsfnum);
      sessionStorage.setItem('LotId', currentLocation.StorageLotId);
      this.LocationName = sessionStorage.getItem('Lot');
      //this.SetCurrentUser();
      this.redirectTo('enterprisedashboard', false);
      //this.router.navigate(['enterprisedashboard']);


    }


  }
  clearusernotificatio(UserId: number) {
    let obj = {
      UserId: this.UserId
    }

    this.notifyservice.ClearNotifications(obj).subscribe((res: any) => {
      if (res.id > 0) {
        //this.dynamicMsg=[];
        this.LoadUserNotifications(this.UserId);
        this.resetNotifications();
        this.toastr.success("Notifications cleared successfully");
        this.notification = this.staticMsg.concat(this.dynamicMsg);
      } else if (res.id == -1) {
        console.log("Error clearing notifications:", res.result);
        this.toastr.error(res.result);
      }
    },
      error => { this.toastr.error(<any>error); });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
